module.exports = __webpack_public_path__ + "static/media/audio-icon.025be509.jpg";